import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { ComponentHeader } from '../component-header/component-header';
import './slideInPage.scss';
import { Loader } from 'components/loaders';
/* children container needs to be added to array for slide in pages in routes to work properly */
function SlideInPage({ children, isFetching = false, mainHeading = '', subHeading = '', showLeftIcon = false, rightIcon = null, }) {
    useEffect(() => {
        document.body.classList.add('popup-open');
        return function cleanUp() {
            document.body.classList.remove('popup-open');
        };
    });
    return (_jsxs("div", { className: "slide_in_page-container", children: [_jsx(ComponentHeader, { mainHeading: mainHeading, subHeading: subHeading, showLeftIcon: showLeftIcon, rightIcon: rightIcon }), _jsx("div", { className: "slide_in_page-content", children: isFetching ? _jsx(Loader, {}) : children })] }));
}
SlideInPage.propTypes = {
    children: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.any),
        PropTypes.objectOf(PropTypes.any),
    ]).isRequired,
    isFetching: PropTypes.bool,
    mainHeading: PropTypes.string,
    subHeading: PropTypes.string,
    showLeftIcon: PropTypes.bool,
    rightIcon: PropTypes.element,
};
export default SlideInPage;
